export interface Buyer {
  name: string
  city: string
  country: string
  flag: string
}

export const buyers: Buyer[] = [
  { name: 'Emma R.', city: 'Norwich', country: 'United Kingdom', flag: '🇬🇧' },
  { name: 'Jacob L.', city: 'Regina', country: 'Canada', flag: '🇨🇦' },
  { name: 'Hannah M.', city: 'Des Moines, IA', country: 'United States', flag: '🇺🇸' },
  { name: 'Lachlan B.', city: 'Toowoomba', country: 'Australia', flag: '🇦🇺' },
  { name: 'Oliver T.', city: 'Exeter', country: 'United Kingdom', flag: '🇬🇧' },
  { name: 'Chloe D.', city: 'Guelph', country: 'Canada', flag: '🇨🇦' },
  { name: 'Ethan W.', city: 'Fresno, CA', country: 'United States', flag: '🇺🇸' },
  { name: 'Sophie K.', city: 'Mildura', country: 'Australia', flag: '🇦🇺' },
  { name: 'George H.', city: 'York', country: 'United Kingdom', flag: '🇬🇧' },
  { name: 'Ava P.', city: 'Kelowna', country: 'Canada', flag: '🇨🇦' },
  { name: 'Lucas S.', city: 'Lincoln, NE', country: 'United States', flag: '🇺🇸' },
  { name: 'Isla F.', city: 'Wagga Wagga', country: 'Australia', flag: '🇦🇺' },
]
